import React, { useState, useEffect } from 'react';
import {v4 as uuidV4} from 'uuid';

import Data from '../data/daimlerBrData.json'

const states = Data.map((data) => data.Estado);

const SELECT_STATE = 'SELECIONE O ESTADO';
const SELECT_CITY = 'SELECIONE A CIDADE';
const SELECT_DEALERSHIP = 'SELECIONE A CONCESSIONARIA';

let uniqueStates = [...new Set(states)].sort()
uniqueStates = [SELECT_STATE, ...uniqueStates];

export default function FormBr () {

    const [state , setState] = useState('');

    const [cities, setCities] = useState([]);
    const [city , setCity] = useState('');

    const [dealerships, setDealerships] = useState([]);
    const [dealership , setDealership] = useState('');
    const [dealershipCode , setDealershipCode] = useState('');

    const [email , setEmail] = useState('');
    const [firstName , setFirstName] = useState('');
    const [lastName , setLastName] = useState('');

    const [formSuccess, setFormSuccess] = useState(false);
    const [formError, setFormError] = useState(false);
    const [emailError, setEmailError] = useState(false);

    const [newForm, setNewform] = useState(false);

    const clearUserInformation = () => {
        setFirstName('');
        setLastName('');
        setEmail('');
    }

    const clearAll = () => {
        clearUserInformation();
        setState(SELECT_STATE)
        setCities([]);
        setCity('');
        setDealerships([]);
        setDealership('');
        setDealershipCode('');
        setFormError(false);
        setEmailError(false);
        setFormSuccess(false);
        setNewform(false);
    }

    const validEmail = (e) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const email = e.target.value;

        const validEmail = re.test(email);

        if (!validEmail) {
            setEmailError(true);
            setFormError(true);
        } else {
            setEmailError(false);
            setFormError(false);
        }
    }
    
    const handleEmail = (e) => {
        setEmail(e.target.value.toUpperCase());
    }

    const handleFirstName = (e) => {
        setFirstName(e.target.value.toUpperCase());
    }

    const handleLastName = (e) => {
        setLastName(e.target.value.toUpperCase());
    }

    const handleNewForm = () => {
        clearAll();
    }

    const handleNewFormKeepDealership = () => {
        clearUserInformation();
        setFormError(false);
        setEmailError(false);
        setFormSuccess(false);
        setNewform(false);
    }

    const handleStateChange = (e) => {
        if (e.target.value === SELECT_STATE) {
            setCity('');
            setDealership('');
            clearUserInformation();
        }
        setState(e.target.value);
    }

    const handleCityChange = (e)=>{
        if (e.target.value === SELECT_CITY) {
            setDealership('');
            clearUserInformation();
        }
        setCity(e.target.value);
    }

    const handleDealershipChange = (e)=>{
        setDealership(e.target.value);
    }

    useEffect(() => {
        let citiesData = Data.filter((data) => data.Estado === state).map((data) => data.Cidade).sort();
        let uniqueCities = [...new Set(citiesData)].sort()
        uniqueCities = [SELECT_CITY, ...uniqueCities];
        setCity(SELECT_CITY)
        setCities(uniqueCities);
    }, [state])

    useEffect(() => {
        let dealershipNames = Data.filter((data) => data.Cidade === city).map((data) => data.Concessionária).sort();
        let uniqueDealerships = [...new Set(dealershipNames)].sort()
        uniqueDealerships = [SELECT_DEALERSHIP, ...uniqueDealerships];
        setDealership(SELECT_DEALERSHIP)
        setDealerships(uniqueDealerships);
    }, [city])

    useEffect(() => {
        const dealershipCodeData = Data.find((data) => data.Estado === state && data.Cidade === city && data.Concessionária === dealership);
        if (dealershipCodeData) {
            setDealershipCode(dealershipCodeData.Código);
        } else {
            setDealershipCode("-");
        }
    }, [dealership])


    const handleSubmit = async (e)=>{
        e.preventDefault();

        setNewform(true);
        
        const id = uuidV4();
        const URL = 'https://voywtbkai8.execute-api.sa-east-1.amazonaws.com/dev/newregister';

        const options = {
            method: 'POST',
            mode: 'no-cors',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                uniqueId: id,
                country: 'BRASIL',
                state: state,
                city: city,
                dealership: dealership,
                dealershipCode: dealershipCode,
                email: email,
                firstName: firstName,
                lastName: lastName
            })
        }

        await fetch(URL, options)
            .then((response) => {
                console.log(response)
                setFormSuccess(true);
            })
            .catch(() => setFormError(true));
    }

    return(
        <form data-toggle="validator" onSubmit={(e) => {handleSubmit(e)}}>
            <div className='container'>
                <div className='card-header mb-3'>
                    <h1> DAIMLER TRUCK - FORMULÁRIO DE PRÉ REGISTRO DO JOGO - PORTUGUÊS	</h1>
                </div>
                <div className='container'>
                    <div className="mb-3">
                        <div className="input-group mb-3 form-group">
                            <span  className="input-group-text"> ESTADO </span>
                            <select className="form-select " value={state} name="state" onChange={(e) => {handleStateChange(e)}}>
                                {
                                    uniqueStates.map((stateMap, index) => <option key={index} value={stateMap}>{stateMap}</option>)
                                }
                            </select>
                        </div>
                    </div>

                    {state && state !== SELECT_STATE 
                    ?
                    <div className="mb-3">
                        <div className="input-group mb-3">
                            <label  className="input-group-text"> CIDADE </label>
                            <select className="form-select" value={city} name="city" onChange={(e) => {handleCityChange(e)}}>
                                {
                                    cities.map((cityMap, index) => <option key={index} value={cityMap}>{cityMap}</option>)
                                }
                            </select>
                        </div>
                    </div>
                    :''}

                    {city && city !== SELECT_CITY
                    ?
                    <div className="mb-3">
                        <div className="input-group mb-3">
                            <label  className="input-group-text"> CONCESSIONÁRIA </label>
                            <select className="form-select" value={dealership} name="dealership" onChange={(e) => {handleDealershipChange(e)}}>
                                {
                                    dealerships.map((dealershipMap, index) => <option key={index} value={dealershipMap}>{dealershipMap}</option>)
                                }
                            </select>
                        </div>
                    </div>
                    :''}
                </div>
                
                { dealership && dealership !== SELECT_DEALERSHIP && city !== SELECT_CITY && state !== SELECT_STATE 
                ?
                <div className='container'>
                    <div className="mb-3">
                        <div className="row">
                            <div className="input-group mb-3 form-group">
                                <label  className="input-group-text"> CÓDIGO DA CONCESSIONÁRIA </label>
                                <input className="form-control text-center" type='text' name='dealershipCode' value={dealershipCode} disabled/>
                            </div>
                        </div>

                        <div className="row">
                            <div className="input-group mb-3 form-group">
                                <label  className="input-group-text"> E-MAIL </label>
                                <input className="form-control" type='text' name='email' value={email} onChange={(e) => {handleEmail(e)}} onBlur = {(e) => {validEmail(e)}}/>
                            </div>
                        </div>

                        <div className="row">
                            <div className="input-group mb-3">
                                <label  className="input-group-text"> PRIMEIRO NOME </label>
                                <input className="form-control" type='text' name='firstName' value={firstName} onChange={(e) => {handleFirstName(e)}}/>
                            </div>
                            <div className="input-group mb-3">
                                <label  className="input-group-text"> ULTIMO NOME </label>
                                <input className="form-control" type='text' name='lastName' value={lastName} onChange={(e) => {handleLastName(e)}}/>
                            </div>
                        </div>
                    </div>
                </div>
                : '' }
                <div className='container  mx-auto style={{"width": "200px"}}'>
                    {
                        newForm ?
                        <div>
                            <button className="btn btn-primary mb-3" type='button' onClick={(e) => {handleNewFormKeepDealership(e)} } >NOVO CADASTRO (MANTENDO A CONCESSIONÁRIA)</button>
                            <button className="btn btn-secondary mb-3 ms-3" type='button' onClick={(e) => {handleNewForm(e)} } >NOVO CADASTRO</button>
                        </div>
                        :
                        state && state !== SELECT_STATE &&
                        city && city !== SELECT_CITY &&
                        dealership && dealership !== SELECT_DEALERSHIP &&
                        email !== '' &&
                        firstName !== '' &&
                        lastName !== '' &&
                        !formError
                        ?
                        <button className="btn btn-success mb-3" type='button' onClick={(e) => {handleSubmit(e)} }>SUBMETER</button>                        
                        :
                        <button className="btn btn-secondary mb-3" type='button' disabled>SUBMETER</button>
                    }
                </div>
                <div className='container'>
                    {
                        formSuccess ? <div className="alert alert-success" role="alert"> CADASTRO REALIZADO COM SUCESSO! </div> : ''
                    }
                    {
                        formError ? <div className="alert alert-danger" role="alert"> OCORREU UM ERRO COM SEU CADASTRO, VERIFIQUE AS INFORMAÇÕES! </div> : ''
                    }
                    {
                        emailError ? <div className="alert alert-danger" role="alert"> SEU EMAIL ESTÁ INCORRETO, POR FAVOR VERIFICAR! </div> : ''
                    }
                </div>
            </div>
        </form>
    )
};
